module.exports = __webpack_public_path__ + "img/blue-and-refreshing.0e15fec2.svg";